module.exports = {
    api_config : {
        api_endpoint : "https://rgcdtp-phstudy-api.rugcc.org/api/v1",
        current_environment : "phstudy"
    }
};